export type { IInputProps, TInputFieldSize } from './input';

export { default } from './input';
export { TextArea } from './textarea';
